<template>
  <el-dialog title="维护镜架类" :visible.sync="dialogVisible"  width="630px" class="themeDialog" center :append-to-body="true"
             :close-on-click-modal="false">
    <div class="formBox">
      <el-form ref="infoForm" :model="formData" :rules="rules" label-width="100px" size="medium">
        <el-form-item label="名称：" prop="categoryname">
          <el-input v-model="formData.categoryname" maxlength="30" show-word-limit style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="产地：" prop="place">
          <el-input v-model="formData.place" show-word-limit style="width: 120px"></el-input>
        </el-form-item>
        <el-form-item label="默认单价：" prop="defaultprice">
          <el-input-number v-model="formData.defaultprice" :controls="false" style="width: 120px" ></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button  @click="cancel">关闭</el-button>
      <el-button type="primary" @click="save" :loading="loading">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {saveData, getDetail} from '@/api/set/jxcgoodscategory';

export default {
  data() {
    let validName = (rule, value, callback) => {
      if (!value) {
        callback()
      } else{
        var hasValue = false;
        for (let i in this.parentCat.children) {
          if (this.parentCat.children[i].text == value&&this.parentCat.children[i].id!=this.formData.categorycode) {
            hasValue = true;
            break;
          }
        }
        if(!hasValue){
          for (let i in this.tableData) {
            if (this.tableData[i].categoryname == value&&this.tableData[i].categorycode!=this.formData.categorycode) {
              hasValue = true;
              break;
            }
          }
        }

        if (hasValue)
          callback(new Error('名称已存在，不允许重复添加！'))
        else
          callback()
      }
    }

    return {
      loading:false,
      dialogVisible: false,
      formData: {
        categorycode: '',
        parentdserial: '',
        categoryname: '',
        place:'',
        defaultprice:'',
        enabled: 1,
        sortnum: '',
        queryproperty: '',
        formproperty: '',
        trademark: '',
        openurl: "",
        advertisement: '',
        tenantid: '',
        filltemplate: '',
        setofbooks:''
      },
      parentCat:{},
      tableData:[],
      rules: {
        categoryname: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' },
          { required: true, validator: validName, trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    show(categorycode,parentCat,tableData) {
      this.loading = false;
      this.parentCat = parentCat;
      this.tableData = tableData;
      this.dialogVisible = true;
      if (categorycode) {
        getDetail({categorycode: categorycode}).then(response => {
          for (let i in this.formData) {
            this.formData[i] = response.data.obj[i];
          }
        })
      } else {
        for (let key in this.formData) {
          this.formData[key]=''
        }
        this.formData.parentdserial=this.parentCat.categorycode;
        this.formData.place=this.parentCat.place;
        this.formData.defaultprice=this.parentCat.defaultprice;
        this.formData.enabled=1;
      }
    },
    cancel() {
      this.dialogVisible = false;
    },
    save() {
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          this.loading=true;
          saveData(this.formData).then(response=>{
            if (response.data.code === 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$emit('bindGrid');
              this.dialogVisible = false;
            } else {
              this.loading=false;
              this.$message.error(response.data.msg);
            }
          })
        }
      });
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/childComp/BrandEdit.vue